import { render, staticRenderFns } from "./PromotionBanners.vue?vue&type=template&id=1ecb3112&scoped=true"
import script from "./PromotionBanners.vue?vue&type=script&lang=js"
export * from "./PromotionBanners.vue?vue&type=script&lang=js"
import style0 from "./PromotionBanners.vue?vue&type=style&index=0&id=1ecb3112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb3112",
  null
  
)

export default component.exports